import { PageController } from '@client/components/_core/layout/PageController';
import { FieldConfigurationList } from '@client/components/field-configurations/FieldConfigurationList';
import { createFileRoute } from '@tanstack/react-router';
import { SlidersHorizontal } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/complaints/custom-fields')({
    staticData: {
        metadata: {
            title: 'Custom fields',
        },
        ui: {
            icon: SlidersHorizontal,
            title: 'Complaint custom fields',
            subtitle: 'Define additional fields captured against complaints',
            menuDescription: 'Define additional fields captured against complaints',
        },
    },
    component: ComplaintCustomFields,
});

function ComplaintCustomFields() {
    return (
        <PageController route={Route}>
            <FieldConfigurationList entity="COMPLAINT" showEntityConfiguration allowDuplicates />
        </PageController>
    );
}
